export const FeatureFlags = {
  flight_plan_submission_enabled: "flight_plan_submission_enabled",
  subscriptions_enabled: "subscriptions_enabled",
}